import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Default";
import Footer from "../../components/Partials/Footer";
import Header from "../../components/Partials/Header";
import { useLocation } from "react-router-dom";
import { getItemMenu, getItemsTeasaureByParent } from "../../assets/js/api";
import { translate } from "../../assets/js/functions";

export default function Glosario({ section_id }) {
    const location = useLocation();
    const [galeria, setGaleria] = useState(null);
    const [trabajos, setTrabajos] = useState(null);
    const [item, setItem] = useState(location.state?.item || null);

    useEffect(() => {
        if (section_id && !item) {
            getItemMenu(section_id).then((foundItem) => {
                setItem(foundItem);
            });
        }
    }, [section_id, item]);

    useEffect(() => {
        if (item) {
            getItemsTeasaureByParent(item, null, true).then((data) => setGaleria(data[0]));
        }
    }, [item]);

    useEffect(() => {
        if (galeria) {
            getItemsTeasaureByParent(galeria, null, true).then((data) => setTrabajos(data));
        }
    }, [galeria]);


    const createTitle = (title) => {
        const words = title.split(" ");

        if (words.length >= 2) {
            words[words.length - 1] = (
                <span className="has-text-primary">{words[words.length - 1]}</span>
            );
        }

        return (
            <>
                {words.map((word, index) => (
                    <React.Fragment key={index}>
                        {word}
                        {index < words.length - 1 && ' '}
                    </React.Fragment>
                ))}
            </>
        );
    };


    return (
        <Layout pageMeta={{}}>
            <div className="page-container py-5 is-flex is-flex-direction-column">
                <Header></Header>
                <main id="main" className="is-relative mb-7">
                    <div className="wrapper flow--xl">
                        <h1 className="has-text-centered">{item ? createTitle(item.term) : ""}</h1>

                    </div>
                    <div className="wrapper wrapper--narrow has-text-centered flow--xs mt-7">
                        <p
                            dangerouslySetInnerHTML={{ __html: item.abstract }}
                        />
                    </div>
                    <div className="wrapper mt-7 flow--xl">
                        <div className="wrapper mt-7 flow--xl">
                            <h2>{galeria ? galeria.title : ""}</h2>
                            {trabajos && trabajos.length > 0 ? (
                                trabajos.map((trabajo, index) => (
                                    <details key={trabajo.id || index}>
                                        <summary>
                                            <h3 className="has-text-weight-bold is-size-5">Colegio</h3>
                                        </summary>
                                        <div className="pt-2 flow is-size-6">
                                            <p>Trabajo alumnado</p>
                                            <div className="columns is-multiline is-variable is-1">
                                                <div className="column is-narrow">
                                                    <button type="button" className="img-btn flow--xs">
                                                        <img src="/media/img/trabajo-01.jpg" alt="" width="261" height="168" className="is-block" />
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                    </details>
                                ))
                            ) : null}


                        </div>

                    </div>

                </main>
                <Footer></Footer>
            </div>
        </Layout>
    );
}